export const keys = {
  required: 'required',
  email: 'email',
  isTrue: 'isTrue',
};
